export default "assets/images/amp-site-logo-sm.png"